export async function newVersionDeployed(
  loaded: string,
  read: typeof fetch = fetch,
): Promise<boolean> {
  try {
    const response = await read(INDEX_PATH, { cache: "no-store" });
    if (!response.ok) return false;
    const deployed = entryScriptOf(await response.text());
    return deployed !== null && deployed !== loaded && stemOf(deployed) === stemOf(loaded);
  } catch {
    return false;
  }
}

export function loadedEntryScript(page: Document = document): string | null {
  const script = page.querySelector<HTMLScriptElement>('script[type="module"][src]');
  return fileNameOf(script?.getAttribute("src") ?? null);
}

export function entryScriptOf(html: string): string | null {
  return loadedEntryScript(new DOMParser().parseFromString(html, "text/html"));
}

function stemOf(fileName: string): string | null {
  const dash = fileName.indexOf("-");
  return dash > 0 && fileName.endsWith(".js") ? fileName.slice(0, dash) : null;
}

function fileNameOf(src: string | null): string | null {
  if (!src) return null;
  const path = new URL(src, "http://simon.invalid").pathname;
  const name = path.slice(path.lastIndexOf("/") + 1);
  return name === "" ? null : name;
}

const INDEX_PATH = "/index.html";
